import { Document, Page } from "react-pdf/dist/esm/entry.webpack";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import React, { useState, useEffect } from "react";
import { IonButton, IonButtons, IonIcon, IonItem, IonLabel, IonText } from "@ionic/react";
import { SizeMe } from "react-sizeme";
import { addOutline, removeOutline } from "ionicons/icons";
import api from "../utils/api";
import { DocumentDownloadButton } from "./DocumentDownloadButton";
import { Document as DocumentType } from "../@types/document";

interface ComponentProps {
  document: DocumentType;
}

export const DocumentViewer: React.FC<ComponentProps> = ({ document }) => {
  const [numPages, setNumPages] = useState<number>(0);
  const [fileUrl, setFileUrl] = useState<string | null>(null);
  const [zoom, setZoom] = useState(1.0);

  useEffect(() => {
    const fetchDocument = async () => {
      const docId = (document.signedArchive || document.archive)?.id;
      if (!docId) {
        console.error("No document ID found for viewing");
        return;
      }

      try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${api.baseURL}archive/${docId}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });

        if (response.ok) {
          const blob = await response.blob();
          const url = URL.createObjectURL(blob);
          setFileUrl(url);
        } else {
          console.error('Error fetching document:', response.statusText);
        }
      } catch (error) {
        console.error('Fetch error:', error);
      }
    };

    fetchDocument();
  }, [document]);

  function onDocumentLoadSuccess({ numPages }: any) {
    setNumPages(numPages);
  }

  const incrementZoom = () => {
    setZoom(+(zoom + 0.1).toFixed(12));
  };

  const decrementZoom = () => {
    setZoom(+(zoom - 0.1).toFixed(12));
  };

  return (
    <section
      style={{
        maxHeight: "calc(100vh - 104px)",
        overflow: "auto",
        background: "#bcbcbc",
      }}
    >
      {fileUrl ? (
        <>
          <SizeMe>
            {({ size }) => (
              <Document
                file={fileUrl}
                onLoadSuccess={onDocumentLoadSuccess}
                loading="Cargando documento..."
                noData="No se ha encontrado el documento"
                className={"doc-viewer"}
              >
                <IonItem color="dark">
                  <IonLabel>
                    <h4>{document.archive?.filename}</h4>
                  </IonLabel>
                  <IonButtons slot="end">
                    <DocumentDownloadButton document={document} />
                  </IonButtons>
                  <IonButtons slot="end" className="ion-margin-start">
                    <IonButton onClick={decrementZoom}>
                      <IonIcon icon={removeOutline}></IonIcon>
                    </IonButton>
                    <IonText>{zoom * 100}%</IonText>
                    <IonButton onClick={incrementZoom}>
                      <IonIcon icon={addOutline}></IonIcon>
                    </IonButton>
                  </IonButtons>
                </IonItem>
                {Array.from(new Array(numPages), (el, index) => (
                  <article
                    style={{ display: "flex", overflow: "auto" }}
                    key={index}
                    className="ion-margin"
                  >
                    <Page
                      key={`page_${index + 1}`}
                      pageNumber={index + 1}
                      width={size.width ? size.width : 1}
                      scale={zoom}
                    />
                  </article>
                ))}
              </Document>
            )}
          </SizeMe>
        </>
      ) : (
        <p>Ha ocurrido un problema con la carga del archivo</p>
      )}
    </section>
  );
};

